<div class="row mb-2">
  <div class="col-md-2" >
    <select [(ngModel)]="searchBy" class="form-control">
      <option value=''>Select Search By</option>
      <option value="packageID">Package ID</option>
      <option value="senderMobile">Sender Mobile</option>
      <option value="senderName">Sender Name</option>
    </select>
  </div>
  <div class="col-md-2">
    <input type="search"  [(ngModel)]="searchText" class="form-control mb-2 " placeholder="Search Text" > 
  </div>
  <div class="col-md-2">
    <button (click)="search()" class="btn btn-primary  btn-block" [disabled]="!searchBy || !searchText" >Search <i class="fa fa-search"></i></button>
  </div>

  <div class="col-md-6 m-0 text-end">
    <button (click)="exportToExcel()" style="margin:0px 5px !important" class="btn-shadow  d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
       Export Current Excel  </button>
       <button  class="btn-shadow d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
        Export All Excel </button>
  </div>
      </div>

<!-- <div class="row mb-2">
  <div class="col-md-6">
      <div> <input type="search" (ngModelChange)="applyFilter($event)" [(ngModel)]="searchText" class="form-control"
              placeholder="Search by package name" style="width: 70%"> </div>
  </div>

  <div class="col-md-6 m-0 text-end">
    <button (click)="exportToExcel()" style="margin:0px 5px !important" class="btn-shadow  d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
       Export Current Excel  </button>
       <button  class="btn-shadow d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
        Export All Excel </button>
  </div>
</div> -->


<div class="main-card mb-3 card">
  <div class="card-header font-weight-B fs-1r">
    All Packers & Movers Requests 
  </div>
  <div class="table-responsive">
    <table class="align-middle mb-0 table table-borderless table-striped table-hover"  id="excel-table">
      <thead>
      <tr>
        <th>Package ID</th>
        <th>Name</th>
        <th>Mobile</th>
        <th>Pick Up Location</th>
        <th>Drop Location</th>
        <th>Package Type</th>
        <th>Created On</th>
        <th>Moving Date</th>
        <th class="text-end">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of allPackerMoverList | paginate : { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems  }">
       
        <td>
          <div class="widget-content p-0">
            <div class="widget-content-wrapper">
              <div class="widget-content-left flex2">
                <div class="widget-heading">{{data.packageID}}
                  
                </div>
              </div>
            </div>
          </div>
        </td>
        <td>
          <div class="widget-content p-0">
            <div class="widget-content-wrapper">
              <div class="widget-content-left flex2">
                <div class="widget-heading">{{data.senderName}}

                </div>
              </div>
            </div>
          </div>
        </td>
        <td>
          <div class="widget-content p-0">
            <div class="widget-content-wrapper">
              <div class="widget-content-left flex2">
                <div class="widget-heading">{{data.senderMobile}}</div>
               
              </div>
            </div>
          </div>
        </td>
        <td>
          <div class="widget-content p-0">
            <div class="widget-content-wrapper">
              <div class="widget-content-left flex2">
                <div class="widget-heading">{{data.fromAddress}}</div>
         
              </div>
            </div>
          </div>
        </td>
        <td>
          <div class="widget-content p-0">
            <div class="widget-content-wrapper">
              <div class="widget-content-left flex2">
                <div class="widget-heading">{{data.toAddress}}</div>
              </div>
            </div>
          </div>
        </td>
        <td>
          <div class="widget-content p-0">
            <div class="widget-content-wrapper">
              <div class="widget-content-left flex2">
                <div class="widget-heading">{{data.selectedPackage.packageType}}</div>
              </div>
            </div>
          </div>
        </td> 
        <td>
          <div class="widget-content p-0">
            <div class="widget-content-wrapper">
              <div class="widget-content-left flex2">
                <div class="widget-heading">{{data.timestamp*1000 | date : "dd MMM yyyy hh:mm a" : "en-IN" }}</div>
           
              </div>
            </div>
          </div>
        </td> 
        <td>
          <div class="widget-content p-0">
            <div class="widget-content-wrapper">
              <div class="widget-content-left flex2">
                <div class="widget-heading">{{data.shiftingDate }}</div>
              
              </div>
            </div>
          </div>
        </td> 
        <td class="text-end">
          <div class="dropdown">
            <button class="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
              Action
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li><a class="dropdown-item" (click)="routeViewDetails(data._id)">View Details <i class="fa fa-eye"></i></a></li>
            </ul>
          </div>
        </td>
      </tr>
     
      </tbody>
      <div *ngIf="allPackerMoverList?.length  == 0" class="text-center mt-5 mb-5" >
        <span class="text-danger">Data Not found</span>
      </div>
      
    </table>
    <!-- <pagination-controls class="my-pagination" (pageChange)="gty((page = $event))"></pagination-controls> -->
    <ngb-pagination
    (pageChange)="gty((page = $event))"
    [collectionSize]="totalItems"
    [(page)]="page"
    [pageSize]="itemsPerPage"
    [maxSize]="3"
    [rotate]="true"
    [boundaryLinks]="false"
  >
  </ngb-pagination>
  </div>
</div>





















































<!-- <div class="row mb-2">
    <div class="col-md-6">
        <div> <input type="search" (ngModelChange)="applyFilter($event)" [(ngModel)]="searchText" class="form-control"
                placeholder="Search by package name" style="width: 70%"> </div>
    </div>

    <div class="col-md-6 m-0 text-end">
      <button (click)="exportToExcel()" style="margin:0px 5px !important" class="btn-shadow  d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
         Export Current Excel  </button>
         <button  class="btn-shadow d-inline-flex align-items-center btn btn-success"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
          Export All Excel </button>
    </div>
</div>


<div class="main-card mb-3 card">
    <div class="card-header font-weight-B fs-1r">
      All Packers & Movers Requests 
    </div>
    <div class="table-responsive">
      <table class="align-middle mb-0 table table-borderless table-striped table-hover"  id="excel-table">
        <thead>
        <tr>
          <th> Name</th>
          <th>Mobile</th>
          <th>Pick Up Location</th>
          <th>Drop Location</th>
          <th>Package Type</th>
          <th>Moving Date</th>
          <th class="text-end">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of allPackerMoverList | paginate : { itemsPerPage: itemsPerPage, currentPage: page, totalItems: totalItems  }">
         
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{data.name}}</div>
              
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{data.mobile}}</div>
                 
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{data.pickupLocation}}</div>
           
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{data.dropLocation}}</div>
         
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{data.packageName}}</div>
             
                </div>
              </div>
            </div>
          </td> 
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{data.movingDate | date:'dd MMM yyyy'}}</div>
                
                </div>
              </div>
            </div>
          </td> 
          <td class="text-end">
            <div class="dropdown">
              <button class="btn btn-info dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                Action
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li><a class="dropdown-item" (click)="routeViewDetails(data._id)">View Details <i class="fa fa-eye"></i></a></li>
              </ul>
            </div>
          </td>
        </tr>
       
        </tbody>
        <div *ngIf="allPackerMoverList?.length  == 0" class="text-center mt-5 mb-5" >
          <span class="text-danger">Data Not found</span>
        </div>
        
      </table>
      <pagination-controls class="my-pagination" (pageChange)="gty((page = $event))"></pagination-controls>
    </div>
  </div> -->